import { BlastEvent, SimulationConfig } from '../../../types';
import { drawBlastShape } from '../../../break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const ShockwaveAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  drawBlastShape(ctx, e, e.maxRadius + progress * 250);
  ctx.lineWidth = 10 * (1 - progress);
  ctx.stroke();
};

registerBlastAnimation('SHOCKWAVE', ShockwaveAnimation);
